/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import {DELETE_TASKS, GET_TASKS} from "../../database/queries/taskQueries";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../../constants/tableIcons";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import PageBar from "../Common/PageBar";
import usePersistentStore from "../../persistentStore";
import {Link, Route, Switch, useHistory, useRouteMatch} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
}));

// const getTaskType = value => {
//     switch (value) {
//         case 'call':
//             return 'Call';
//         case 'email':
//             return 'Email';
//         case 'text':
//             return "Text Message";
//         default:
//             return "Unknown";
//     }
// };
//
// const getTaskStatus = value => {
//     switch (value) {
//         case 'not_started':
//             return 'Not Started';
//         case 'in_progress':
//             return 'In Progress';
//         case 'on_hold':
//             return "On Hold";
//         case 'completed':
//             return "Completed";
//         case 'cancelled':
//             return "Cancelled";
//         default:
//             return "Unknown";
//     }
// };

const PopupTaskList = props => {
    const classes = useStyles();
    const [globalPersistentState] = usePersistentStore();
    const [searchStr, setSearchStr] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [tasks, setTasks] = useState(null);
    const [globalLayoutState] = useLayoutStore();
    let {url} = useRouteMatch();
    const history = useHistory();

    let columns = [
        {
            title: 'Name',
            render: r => {
                return (
                    <Link to={`${url}/${r.taskId}`}>
                        {r.taskName}
                    </Link>
                );
            },
        },
        {title: 'Type', field: 'taskType'},
        {title: 'Status', field: 'taskStatus'},
        {title: 'Priority', field: 'taskPriority'},
    ];

    const {loading: getTasksLoading, error: getTasksError, data: getTasksData, refetch: getTasksRefetch} = useQuery(GET_TASKS, {
        // skip: props.match.params.taskId,
        variables: {
            parentType: props.editType ? props.editType : null,
            parentId: props.editId ? props.editId : null,
            shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
            shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
            searchStr: searchStr,
            // limit: 10,
            // offset: 0,
            // showCompleted: showCompleted,
            orderList: ['updatedAt DESC']
        },
    });

    const [deleteTasks, {error: deleteTasksError}] = useMutation(DELETE_TASKS);

    const handleSearch = (s) => {
        setSearchStr(s);
        getTasksRefetch();
    };

    const handleRefresh = () => {
        getTasksRefetch();
    };

    const handleDelete = () => {
        const selectedIds = selectedRows.map(row => row.taskId);
        deleteTasks({
            variables: {deleteTaskIds: selectedIds}
        }).then(deleteTasksResult => {
            if (deleteTasksResult.data.deleteTasks.returnCode === 0) {
                notify('deleteTasks', 'info', deleteTasksResult.data.deleteTasks.message, null, null, globalPersistentState.popupQueryObj);
            } else {
                notify('deleteTasks', 'error', deleteTasksResult.data.deleteTasks.message, null, null, globalPersistentState.popupQueryObj);
            }
            getTasksRefetch();
        }).catch(e => {
            notify('deleteTasks', 'error', e.message, null, null, globalPersistentState.popupQueryObj);
            getTasksRefetch();
        })
    };

    useEffect(() => {
        getTasksRefetch();
    }, [getTasksRefetch]);

    useEffect(() => {
        if (deleteTasksError) notify('deleteTaskError', 'error', deleteTasksError.message, null, null, globalPersistentState.popupQueryObj);
        if (getTasksError) notify('getTasksError', 'error', getTasksError.message, null, null, globalPersistentState.popupQueryObj);
    }, [deleteTasksError, getTasksError]);

    useEffect(() => {
        if (getTasksData && getTasksData.tasks) {
            let myTasks = [];
            getTasksData.tasks.map(task => {
                let myTask = {...task};
                if (myTask.account) {
                    myTask.entityType = 'Account';
                    myTask.entityName = myTask.account.accountName;
                } else if (myTask.contact) {
                    myTask.entityType = 'Contact';
                    myTask.entityName = myTask.contact.contactLastFirstName;
                } else if (myTask.project) {
                    myTask.entityType = 'Project';
                    myTask.entityName = myTask.project.projectName;
                } else {
                    myTask.entityType = 'General';
                }
                myTasks.push(myTask);
                return myTask;
            });
            setSelectedRows([]);
            setSelectedObj({});
            setTasks(myTasks);
        }
    }, [getTasksData]);

    useEffect(() => {
        if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionText) {
            console.log('## SVR popupTaskList ## changing history', `${url}/new`);
            history.push(`${url}/new`);
        }
    }, []);

    return (
        <div>
            <Switch>
                <Route exact path={`${url}`}>
                    <div className={classes.root}>
                        <PageBar
                            // title={`Tasks ${props.editObj ? 'of ' + props.editObj.displayName : ''}`}
                            handleSearch={handleSearch}
                            handleRefresh={handleRefresh}
                            handleAdd={() => {
                                console.log('## SVR popupTaskList ## changing history', `${url}/new`);
                                history.push(`${url}/new`);
                            }}
                            handleEdit={() => {
                                console.log('## SVR popupTaskList ## changing history', `${url}/${selectedObj.taskId}`);
                                history.push(`${url}/${selectedObj.taskId}`);
                            }}
                            editDisabled={selectedRows.length !== 1}
                            tagDisabled={selectedRows.length === 0}
                            handleDelete={handleDelete}
                            deleteDisabled={selectedRows.length === 0}
                            exportDisabled={selectedRows.length === 0}
                            showLoading={getTasksLoading}
                        >
                        </PageBar>
                        {tasks && (
                            <SizeMe>
                                {({size}) => {
                                    let height = size.height;
                                    if (!height) height = window.innerHeight;
                                    const fudge = 70;
                                    const tableOptions = {
                                        actionsColumnIndex: -1,
                                        header: true,
                                        maxBodyHeight: height - (globalLayoutState.editTabBarHeight + globalLayoutState.shareSelectBarHeight + fudge),
                                        padding: 'dense',
                                        paging: false,
                                        selection: true,
                                        selectionProps: r => ({
                                            name: r.taskName.replace(/\s+/g, '-').toLowerCase() === '___test' ? 'checkTest' : ''
                                        }),
                                        toolbar: false,
                                    };

                                    return (
                                        <MaterialTable
                                            columns={columns}
                                            data={tasks}
                                            icons={tableIcons}
                                            options={tableOptions}
                                            onSearchChange={(str) => {
                                                setSearchStr(str);
                                            }}
                                            onSelectionChange={(rows) => {
                                                setSelectedRows(rows);
                                                if (rows.length === 1) {
                                                    setSelectedObj(rows[0])
                                                } else {
                                                    setSelectedObj({})
                                                }
                                            }}
                                        />
                                    );
                                }}
                            </SizeMe>
                        )}
                    </div>
                </Route>
                <Route path={`${url}/:editId`}>
                    {cloneElement(props.parent.routes.edit.component, {
                        ...props,
                        parentEditType: props.editType,
                        parentEditId: props.editId,
                        parentRefresh: () => {
                            getTasksRefetch()
                        },
                        editType: 'task',
                        parent: props.parent.routes.edit
                    })}
                </Route>
            </Switch>
        </div>
    )
};

export default PopupTaskList
